import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { ConfigService } from '@aiwyn/config';
import { map, mapTo, switchMap } from 'rxjs/operators';
import { ROUTE_TOKEN_MAIN_BASE, ROUTE_TOKEN_UNDER_MAINTENANCE } from '../routing-constants';

@Injectable({
  providedIn: 'root',
})
export class UnderMaintenanceGuard  {

  constructor(
    private readonly configService: ConfigService,
    private readonly router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.configService.configValuesLoaded$.pipe(
      map(() => this.configService.siteStatusMessage == undefined),
      switchMap(siteActive => {
        const isNavigatingToUnderMaintenancePage = route.url.reverse()[0].path === ROUTE_TOKEN_UNDER_MAINTENANCE;
        if (
          (!siteActive && isNavigatingToUnderMaintenancePage) // can nav to under maintenance page if site is inactive
          || (siteActive && !isNavigatingToUnderMaintenancePage) // can nav to any page other than splash if site is active
        ) {
          return of(true);
        }

        return from(this.router.navigateByUrl(siteActive ? ROUTE_TOKEN_MAIN_BASE : ROUTE_TOKEN_UNDER_MAINTENANCE)).pipe(
          mapTo(false),
        );
      }),
    );
  }
}
